import axios from "axios";

const server = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

export const getProjects = async () => {
  const projectsResponse = await server.get("/pages/project");
  const categoriesResponse = await server.get("/pages/categories");

  const formatedProjects = categoriesResponse?.data?.data?.page?.sections?.map(
    (category) => ({
      ...category,
      projects: projectsResponse?.data?.data?.page?.sections?.filter(
        (project) => project?.category === category?.slug
      ),
    })
  );
  return formatedProjects;
};

export default server;
